module.exports = __webpack_public_path__ + "static/p05_pollito01-6bd4b048d370609a5a1cbcf2bc94564a.png";